import { Component, Input } from '@angular/core';
import { CmsService } from 'src/_service/CmsService';
import { NgClass, NgTemplateOutlet } from '@angular/common';
import { Button, CmsUrl } from 'src/_model/storyblock';
import { RouterLink, UrlSerializer } from '@angular/router';

@Component({
    selector: 'app-cms-button',
    templateUrl: './cms-button.component.html',
    imports: [NgClass, RouterLink, NgTemplateOutlet]
})
export class CmsButtonComponent {

  private _button:Button;
  @Input() set button (value: Button){
    this._button = new Button(value._uid, value._editable, value.title,value.hidden, value.subtitle, value.type, value.colorname, value.URL);
    if(value.title)
      this.renderedTitle = this._cmsService.render_rt(value.title);
    if(value.URL)
      this.get_href(value.URL)
  }
  get button(){return this._button}

  @Input() removeMargin: boolean = false
  renderedTitle: any;
  href: string;
  queryparams: any;
  fragment: string;

  constructor(
    private _cmsService: CmsService,
    private _urlSerializer: UrlSerializer,
  ) {
  }


  get_content(content) {
    return this._cmsService.get_content(content);
  }

  get_class(type){
    let buttonClasses = this._get_class(type);
    if(this.button.color){
      buttonClasses = buttonClasses.replace(/\bhover:text-e[a-zA-Z\-]*\b/gm, '') //replaces all the hover text color classes
      buttonClasses = buttonClasses.replace(/\btext-e[a-zA-Z\-]*\b/gm, '') //replaces all the text color classes
      buttonClasses = buttonClasses.replace('text-white', '') //replaces the white text color classes
      buttonClasses = buttonClasses.replace(/\bhover:bg-e[a-zA-Z\-]*\b/gm, '') //replaces all the background color classes
      buttonClasses = buttonClasses.replace(/\bbg-e[a-zA-Z\-]*\b/gm, '') //replaces all the background color classes
    }
    return buttonClasses;
  }

  private _get_class(type) {    
    switch (type) {
      case 'PLAIN':
        return 'text-e-light-green underline'
      case 'SMALL':
        return 'button-small inline-block'
      case 'BIG':
        return `button-big inline-block pt-[20px]`
      case 'BIG_DARKGREEN':
        return 'button-card bg-e-dark-green text-e-reg-green text-left'
      case 'ORANGE':
        return 'button-base flex rounded-lg bg-e-orange text-white hover:bg-e-light-green hover:text-e-dark-green'
      default:
        return `button-base rounded-full inline-block  w-full sm:w-auto mx-auto ${this.removeMargin? '': 'mt-4 md:mr-4'}`
    }

  }

  get_href(url_field: CmsUrl) {
    // make all urls relative inside out domains
    this.href = url_field.cached_url.trim().replace(/^(?:https?:\/\/)?(www\.)?ekomenu\.(nl|be)/, '');
    // try the correct translated slug if available

    if(url_field.linktype === 'story' && !!url_field.id ){
      this.href = this._cmsService.getHrefForLanguage(url_field.id, )
    }

    //splits the url into seperate parts to make sure that the url works and all elements are seperate in the routerlink directive
    if(this.href?.startsWith("/") ){
        const result = this._urlSerializer.parse(this.href);
        
        this.fragment = result.fragment;
        this.queryparams = result.queryParams

        result.fragment = null;
        result.queryParams = {};
        this.href = this._urlSerializer.serialize(result)
    }

    if (url_field.linktype === 'email') {
      this.href = 'mailto:' + this.href;
    }
    if (url_field.anchor) {
      this.fragment = url_field.anchor;
      if(!this.href?.startsWith("/"))
        this.href += '#' + url_field.anchor

    }
    // TODO: move this logic to the service
    // return this._cmsService.get_href(url_field);
  }

  //when used this in the template the content gets other keys constantly
  // render_rt(content) {
  //   return this._cmsService.render_rt(content);
  // }
  
  get_src(field, contain, height?, width?) {
    return this._cmsService.get_src(field, contain, height, width);
}
  get_classes(card) {
    return this._cmsService.get_classes(card);
  }

}



